/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */
 
 <template>
    <div class="info-card quote-review-card">
        <h4>Desglose de Costo de Cotización</h4>

        <div class="quote-review-item">
            <span>Precio de paneles</span>
            <span>{{ formatCurrency(quoteTotals.precioPaneles) }}</span>
        </div>
        <div class="quote-review-item">
            <span>Precio de inversores</span>
            <span>{{ formatCurrency(quoteTotals.precioInversores) }}</span>
        </div>
        <div class="quote-review-item">
            <span>Precio <strong>material eléctrico</strong></span>
            <span>{{ formatCurrency(quoteTotals.totalConMargen10) }}</span>
        </div>
        <div class="quote-review-item">
            <span>Precio por tipo de <strong>estructura/ferretería</strong></span>
            <span>{{ formatCurrency(quoteTotals.totalEstructura) }}</span>
        </div>
        <div class="quote-review-item">
            <span>Mano de obra</span>
            <span>{{ formatCurrency(quoteTotals.manoObra) }}</span>
        </div>
        <div class="quote-review-item">
            <span>Otros cargos</span>
            <span>{{ formatCurrency(quoteTotals.otrosCargos) }}</span>
        </div>

        <div class="quote-review-item subtotal">
            <span>Subtotal</span>
            <span>{{ formatCurrency(quoteTotals.grandSubtotal) }}</span>
        </div>
        <div class="quote-review-item iva" v-if="quoteTotals.aplicarIVA">
            <span>I.V.A. 16%</span>
            <span>{{ formatCurrency(quoteTotals.ivaAmount) }}</span>
        </div>
        <div class="quote-review-item grand-total">
            <span>GRAN TOTAL EN PESOS</span>
            <span>{{ formatCurrency(quoteTotals.grandTotal) }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DesgloseCostos',
    props: {
        quoteTotals: {
            type: Object,
            required: true,
            default: () => ({
                precioPaneles: 0, precioInversores: 0, totalElectrico: 0,
                totalEstructura: 0, manoObra: 0, otrosCargos: 0,
                grandSubtotal: 0, ivaAmount: 0, grandTotal: 0, aplicarIVA: false, totalElectricoDC: 0, totalElectricoAC: 0, totalConMargen10:0,
            })
        }
    },
    methods: {
        formatCurrency(value) {
            if (typeof value !== 'number' || isNaN(value)) return '$0.00 MXN';
            return value.toLocaleString('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 });
        }
    }
}
</script>

<style scoped>
.info-card {
    background-color: var(--color-fondo-claro, #f8fafc);
    border-radius: 12px;
    padding: 25px;
    border: 1px solid var(--color-borde, #e2e8f0);
    margin-bottom: 25px;
}

.info-card h4 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px;
    border-bottom: 1px solid #e2e8f0;
    padding-bottom: 10px;
}

.quote-review-item {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #e9eef2;
    font-size: 14px;
}

.quote-review-item:last-child {
    border: none;
}

.quote-review-item.subtotal,
.quote-review-item.grand-total {
    font-weight: bold;
}

.quote-review-item.grand-total {
    font-size: 16px;
    border-top: 1px solid #e2e8f0;
    padding-top: 15px;
    margin-top: 10px;
}
</style>